<template>
    <div class="address-item">
        <header>
            <span v-if="index == 0">Адрес отправки</span>
            <span v-if="index == 1 && store.order.addresses.length == 2">Адрес доставки</span>
            <span v-if="index != 0 && store.order.addresses.length > 2">Адрес доставки №{{index}}</span>
            <button type="button" @click="store.deleteAddress(index)" class="close" v-if="index > 1">&times;</button>
        </header>
        <div class="content">
            <div class="line line-address">
                <SearchAddress
                        :key="index"
                        :store="store"
                        :index="index"
                        :Api="Api"
                        :isOpen="false"
                />
                <button type="button" @click="store.showModal(index)">
                    Отметить на карте
                </button>
            </div>
            <div class="line line-extend">
                <vue-numeric
                        :minus="false"
                        separator=""
                        thousand-separator=""
                        placeholder="Подъезд"
                        v-model="store.order.addresses[index].entrance"
                ></vue-numeric>
                <vue-numeric
                        :minus="false"
                        separator=""
                        thousand-separator=""
                        placeholder="Квартира"
                        v-model="store.order.addresses[index].flat"
                ></vue-numeric>
                <date-picker
                        :time-picker-options="{start: '00:00', step:'00:30' , end: '23:30'}"
                        v-model="store.order.addresses[index].time"
                        lang="ru"
                        type="time"
                        format="HH:mm"
                        placeholder="Время доставки"
                />
            </div>

            <div class="link-more"
                 v-bind:class="getLinkClass(index)">
                <a
                    @click="toggleShow(index, !isShow(index))"
                >
                    <span v-if="!isShow(index)">Дополнительно</span>
                    <span v-if="isShow(index)">Скрыть</span>
                </a>
            </div>

            <div class="more" v-if="isShow(index)">
                <div class="line line-member">
                    <input type="text" v-model="store.order.addresses[index].member" class="member" placeholder="Контактное лицо">
                    <masked-input mask="\+1 (111) 111-11-11" v-model="store.order.addresses[index].phone" placeholder="Телефон" type="tel"/>
                    <input type="hidden" v-model="store.order.addresses[index].lat">
                    <input type="hidden" v-model="store.order.addresses[index].lng">
                </div>
                <div class="line">
                    <textarea placeholder="Комментарий" v-model="store.order.addresses[index].comment"></textarea>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import SearchAddress from '../../../elements/SearchAddress';
    import MaskedInput from 'vue-masked-input';
    import DatePicker from 'vue2-datepicker';
    import VueNumeric from 'vue-numeric';
    export default {
        props: ['address', 'index', 'store', 'Api'],
        components: {
            MaskedInput, DatePicker, VueNumeric, SearchAddress
        },
        methods: {
            getLinkClass: function(index){
                let result = [];
                if (this.isShow(index)){
                    result.push('show')
                }
                return result;
            },
            isShow: function(index){
                return typeof this.showList[index] != "undefined" && this.showList[index] == true;
            },
            toggleShow: function(index, state = true){
                this.$set(this.showList, index, state);
            }
        },
        data(){
            return {
                showList: {}
            };
        }
    }
</script>
<style lang="scss">
    #yacurier-form {
        .address-item {
            margin-bottom: 15px;
            position: relative;
            &:before {
                background: #C3C8D7;
                bottom: -35px;
                content: "";
                display: block;
                height: 35px;
                left: 15px;
                position: absolute;
                width: 1px;
                z-index: 1;
            }
            header {
                align-items: center;
                background: #FBFBFB;
                border: 1px solid #C3C8D7;
                border-top-left-radius: 3px;
                border-top-right-radius: 3px;
                color: #333;
                display: flex;
                font-size: 14px;
                padding: 10px 10px;

                &:before {
                    background: #C3C8D7;
                    border-radius: 50%;
                    content: "";
                    height: 8px;
                    margin-right: 10px;
                    width: 8px;
                }

                button.close {
                    background: none;
                    border: none;
                    color: #333;
                    font-size: 20px;
                    margin-left: auto;
                    opacity: .45;

                    &:hover {
                        opacity: 1;
                    }
                }
            }
            .content {
                background: #FAFAFA;
                border: 1px solid #C3C8D7;
                border-top: none;
                border-bottom-left-radius: 3px;
                border-bottom-right-radius: 3px;
                padding: 10px;
                .line{
                    display: flex;
                    margin: 10px -10px 0;
                    &:first-child{
                        margin-top: 0;
                    }
                    > *{
                        margin-left: 10px;
                        margin-right: 10px;
                    }
                    &.line-address{

                        .search-input-field{
                            flex-grow: 1;
                            flex-shrink: 0;
                            margin-right: 0;
                            input[type="text"] {
                                border-right: none;
                            }
                        }
                        button{
                            background-color: #FFD957;
                            border-color: #FFD957;
                            border-left: none;
                            border-radius: 3px;
                            border-bottom-left-radius: 0;
                            border-top-left-radius: 0;
                            color: #60605D;
                            flex-grow: 0;
                            flex-shrink: 1;
                            font-size: 12px;
                            margin-left: 0;
                            padding: 0 10px;
                            text-align: center;
                            transition: background-color .125s ease-in;
                            &:hover{
                                background-color: #ffd043;
                            }
                        }
                        @media(max-width: 478px){
                            flex-wrap: wrap;
                            .search-input-field{
                                margin-right: 10px;
                                width: calc(100% - 20px);
                                input[type="text"] {
                                    border-right: 1px solid #C3C8D7;
                                }

                            }
                            button{
                                font-size: 12px;
                                margin: 10px;
                                padding: 10px;
                                text-align: center;
                                width: calc(100% - 20px);
                            }
                        }
                    }
                    &.line-extend{

                        > *{
                            width: calc(33.33% - 20px);
                        }
                        @media (max-width: 768px) {
                            flex-wrap: wrap;
                            > *{
                                margin-top: 10px;
                                width: calc(100% - 20px);
                                &:first-child{
                                    margin-top: 0;
                                }
                            }
                        }
                    }
                    &.line-member{

                        > *{
                            width: calc(50% - 20px);
                        }
                        @media (max-width: 768px) {
                            flex-wrap: wrap;
                            > *{
                                margin-top: 10px;
                                width: calc(100% - 20px);
                                &:first-child{
                                    margin-top: 0;
                                }
                            }
                        }
                    }
                }

                .link-more{
                    margin: 10px 0;
                    a {
                        border-bottom: 1px dashed #333;
                        color: #333;
                        cursor: pointer;
                        font-size: 12px;
                        text-decoration: none;
                        transition: border-color .125s ease-in;
                        &:hover {
                            border-bottom-color: transparent;
                        }
                    }
                }

            }
            &:last-child {
                &:before {
                    display: none;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/blocks/FullForm/components/AddressItem.vue